import AwesomeLoaders from "../../../../pages/docs/code/rug";
import GettingStarted from "../../../../partials/getting-started.mdx";
import * as React from 'react';
export default {
  AwesomeLoaders,
  GettingStarted,
  React
};